// Predefined guide flows — the "fast path": the AI (or any caller) starts a
// curated walkthrough by id instead of authoring steps. One file per scenario; this
// barrel assembles the registry. Copy lives in the `guide` i18n namespace
// (fr/en/es); targets are STATIC data-testid literals only — template-composed
// ids (`recap-view-tab-${key}`) are not allowed because the drift-guard test
// (`__tests__/walkthroughsDriftGuard.test.ts`) verifies every target against the
// source statically and would (rightly) fail.
//
// Conceptual tours (2–4 steps), not click-by-click scripts. Each step is either
// an ACTION step (advances on the user's own action — `navigate` / `appear` /
// `click-target`, no button) or an EXPLAIN step (spotlight + one-line caption +
// a "Suivant"/"Terminé" button, `advanceOn: "next"`). Reusable step fragments
// live in `steps/shared.ts`.
import type { GuideWalkthroughDef } from "../types";
import { batchEditLines } from "./batch-edit-lines";
import { createTransportLine } from "./create-transport-line";
import { focusTransportTour } from "./focus-transport-tour";
import { openOrderEmail } from "./open-order-email";
import { positionsTour } from "./positions-tour";

export const GUIDE_WALKTHROUGHS: readonly GuideWalkthroughDef[] = [
  positionsTour,
  batchEditLines,
  openOrderEmail,
  focusTransportTour,
  createTransportLine,
];

export function getGuideWalkthrough(
  walkthroughId: string,
): GuideWalkthroughDef | undefined {
  return GUIDE_WALKTHROUGHS.find(
    (walkthrough) => walkthrough.id === walkthroughId,
  );
}
